export default __webpack_public_path__ + "static/media/50.2c4d8dbd.jpeg";